import React, {useCallback} from 'react';

import {Skeleton} from 'src/components/skeleton';

import ComboBox, {ComboboxItem} from '@pb/kit-component-combo-box';
import Label from '@pb/kit-component-label';


import {AdminRoleSelectSkeleton} from './admin-role-select-skeleton';

import type {ProfileRecord} from 'src/openapi/admin/models/ProfileRecord';

type Props = {
    isLoading: boolean,
    disabled?: boolean,
    roles: ProfileRecord[] | null,
    selectedRoles: ProfileRecord[] | null,
    changeRoles: (roles: ProfileRecord[] | null) => void,
};

export const AdminRolesSelect = ({isLoading, disabled, roles, selectedRoles, changeRoles}: Props) => {
    const onChange = useCallback((roleIds: number | number[]) => {
        if (roles) {
            const newRoles = roles.filter(({profileId}) => (roleIds as number[]).includes(profileId));
            changeRoles?.(newRoles.length ? newRoles : null);
        }
    }, [roles, changeRoles]);

    return (
        <Skeleton shown={isLoading} view={<AdminRoleSelectSkeleton/>}>
            <div style={{width: 400}}>
                <Label>Admin Roles</Label>
                {roles ? (
                    <ComboBox
                        disabled={disabled}
                        value={selectedRoles?.map(role => role.profileId) || [-1]}
                        onChange={onChange}
                        multiple={!!changeRoles}
                        placeholder="All Admin Roles">
                        {[
                            ...roles.map(({profileId, profileName}) => (
                                <ComboboxItem key={profileId} value={profileId} caption={profileName}/>
                            )),
                        ]}
                    </ComboBox>
                ) : null}
            </div>
        </Skeleton>
    );
};
